export const isMobileScreen = () => {
  return window.innerWidth < 992;
};
